import { useEffect } from "react";
import Moment from 'react-moment';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import { Card, CardBody, Table } from "reactstrap";

import { getCreditMemos } from "services/credit.service";
import { setGetMethod } from "reducers/dto.slice";

import { DEMO_EMAIL } from "appConstants";
import DataFilters from "components/shared/DataFilters"
import Paging from "components/shared/Paging";
import DownloadPdf from "components/shared/DownloadPdf";
import TableEmptyState from "components/shared/TableEmptyState";
import { setDemoCredits } from "../reducers/credit.slice";

const CreditMemos = () => {

    const customer = useAppSelector(x => x.customers.selectedCustomer);
    const creditMemos = useAppSelector(x => x.creditMemos.creditMemosDto.items);
    const searchDto = useAppSelector(x => x.dtos.searchTransactionDto);
    const creditsLoading = useAppSelector(x => x.creditMemos.loading);
    const creditsError = useAppSelector(x => x.creditMemos.error);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (customer?.email === DEMO_EMAIL) {
            dispatch(setDemoCredits());
        } else if (customer) {
            dispatch(getCreditMemos(searchDto));
            dispatch(setGetMethod(getCreditMemos));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, customer]);
    
    return (
        <Card className="shadow">
            <DataFilters />
            <CardBody>
                <Table bordered striped responsive className="bcd-data-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Purchase Order</th>
                            <th>Credit Memo</th>
                            <th>RMA</th>
                            <th>Total</th>
                            <th>Item Numbers</th>
                            <th>Date Issued</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {creditMemos.length > 0 ? creditMemos.map(o => {
                            return (<tr key={o.transactionId}>
                                <td width="10%">
                                    <Moment format="MM/DD/YYYY">
                                        {o.transactionDate}
                                    </Moment>
                                </td>
                                <td width="15%">
                                    <DownloadPdf model={{ fileId: o.purchaseOrder || "", fileName: o.purchaseOrder || "", recordType: "purchaseOrder" }} />
                                </td>
                                <td width="10%">
                                    <DownloadPdf model={{ fileId: o.transactionId?.toString() || "", fileName: o.creditMemoNumber || "", recordType: "creditMemo" }} />
                                </td>
                                <td width="10%">
                                    {o.rmaNumber &&
                                        <DownloadPdf model={{ fileId: o.returnId?.toString() || "", fileName: o.rmaNumber || "", recordType: o.rmaNumber.startsWith("INV") ? "invoice" : "return" }} />
                                    }
                                </td>
                                <td width="5%">${o.total?.toLocaleString('en-us', { minimumFractionDigits: 2 })}</td>
                                <td>{o.itemNumbers}</td>
                                <td width="10%">
                                    {o.creditIssuedOn &&
                                        <Moment format="MM/DD/YYYY">
                                            {o.creditIssuedOn}
                                        </Moment>}
                                </td>
                                <td width="15%">{o.status}</td>
                            </tr>);
                        })
                            :
                            <TableEmptyState colSpan={8} isLoading={creditsLoading} error={creditsError} entityName="Credit Memos" />
                        }
                    </tbody>
                </Table>
                <Paging />
            </CardBody>
        </Card>
    );
}

export default CreditMemos;